import React, { FC } from 'react'

import ClickWrapModalContextProvider from '../context/ClickWrapModalContextProvider'

const withClickWrapModalContextProvider = <TProps extends Record<string, unknown>>(
  ComponentToWrap: React.ComponentType<TProps>,
): FC<TProps> => {
  const WithClickWrapModalContextProvider: FC<TProps> = (props: TProps) => {
    return (
      <ClickWrapModalContextProvider>
        <ComponentToWrap {...props} />
      </ClickWrapModalContextProvider>
    )
  }
  return WithClickWrapModalContextProvider
}

export default withClickWrapModalContextProvider
